exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-control.custom-radio[data-v-3315bd14]{\n\tpadding-left: 0 !important;\n}\n.custom-control.custom-radio input[data-v-3315bd14]{\n\tpadding-right: 5px !important;\n}\n", ""]);

// exports
